module.exports = {"oops":"Ooops...","oopsTitle":"Det har oppstått en feil","notFound":"Ikke funnet"}


//////////////////
// WEBPACK FOOTER
// ./src/locale/no/error.json
// module id = P5iQ
// module chunks = 23